import { useSWR } from '@tiger/swr';
import { FC, useEffect, useState } from 'react';
import Portal from 'components/Portal';
import { Fade } from 'components/Transition';
import useMediaQuery from 'hooks/useMediaQuery';
import API from 'utils/API';
import classlist from 'utils/classlist';
import PortalMobile from './PortalMobile';
import PortalPC from './PortalPC';
import { TelcodesCountry } from './type';
import './style.scss';

interface TelcodesProps {
    value?: string; // 值，国际区码数字的字符串
    onChange?(value: string): void; // 选择区码后的回调
    disabled?: boolean; // 禁止选择
}

const Telcodes: FC<TelcodesProps> = ({ value = '1', onChange, disabled = false }) => {
    const [show, setShow] = useState(false);
    const [countries, setCountries] = useState<TelcodesCountry[]>([]);
    const { data } = useSWR(API.CUSTOMER.fields.country_us_group(), {
        dataChain: res =>
            res.data.map(item => ({
                ...item,
                items: item.items.map(subItem => ({
                    ...subItem,
                    tel_code: String(subItem.tel_code) // 确保tel_code是字符串
                }))
            })),
        immutable: true
    });
    const isSmScreen = useMediaQuery();

    useEffect(() => {
        if (data) {
            setCountries(data);
        }
    }, [data]);

    // 点击telcode框
    const handleClickTelcode = e => {
        e.stopPropagation();
        showPanel(!show);
    };

    // 弹框, pc | mobile
    const showPanel: (isShow: boolean) => void = isShow => {
        if (disabled || !countries) {
            return;
        }

        setShow(isShow);
    };

    // 改变表单值，隐藏弹框
    const handleChange: (value: string) => void = value => {
        onChange!(value);
        showPanel(false);
    };

    return (
        <div
            className={classlist('telcodes-component-root', {
                'telcodes-expand-pc': !isSmScreen && show
            })}>
            <div
                className={classlist('form-control', { disabled, 'not-disabled': !disabled })}
                onClick={handleClickTelcode}>
                <span className="code">{String(value!).replace(/^\+?/, '+')}</span>
            </div>

            {countries && isSmScreen && (
                <Fade in={show}>
                    <Portal>
                        <PortalMobile
                            hide={() => showPanel(false)}
                            onChange={handleChange}
                            countryData={countries}
                            telcode={value!}
                        />
                    </Portal>
                </Fade>
            )}

            {countries && !isSmScreen && (
                <Fade in={show}>
                    <PortalPC hide={() => showPanel(false)} onChange={handleChange} countryData={countries} />
                </Fade>
            )}
        </div>
    );
};

export default Telcodes;
